var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorderSolidLarge = function SvgBorderSolidLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h38v3a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
  })));
};
export { SvgBorderSolidLarge as ReactComponent };
export default __webpack_public_path__ + "fbc1eeb03e9f95eda4c90b23fc1f15e7.svg";